import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { expires: String };
  static targets = ["container", "indicator", "label", "time"];

  connect() {
    this.updateCountdown();
    this.timer = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  updateCountdown() {
    const now = new Date();
    const expires = new Date(this.expiresValue);
    const diff = expires - now;

    if (diff <= 0) {
      // Update to expired state
      if (this.hasContainerTarget) {
        this.containerTarget.classList.remove(
          "text-orange-600",
          "bg-orange-50"
        );
        this.containerTarget.classList.add("text-red-600", "bg-red-50");
      }

      if (this.hasIndicatorTarget) {
        this.indicatorTarget.classList.remove("bg-orange-500", "animate-pulse");
        this.indicatorTarget.classList.add("bg-red-500");
      }

      if (this.hasLabelTarget) {
        this.labelTarget.textContent = "Expired";
      }

      if (this.hasTimeTarget) {
        this.timeTarget.textContent = "";
      } else {
        // Fallback for old single-element structure
        this.element.textContent = "Expired";
        this.element.classList.remove("text-green-600");
        this.element.classList.add("text-red-600");
      }

      if (this.timer) {
        clearInterval(this.timer);
      }
      return;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    const timeText =
      hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;

    if (this.hasTimeTarget) {
      this.timeTarget.textContent = timeText;
    } else {
      // Fallback for old single-element structure
      this.element.textContent = timeText;
    }
  }
}
